import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { SSL_ACCESS_REVOKED_EVENT } from "@/shared/api";
import { Button } from "../button";

export const AccessRevokedOverlay = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onRevoked = () => setOpen(true);
    window.addEventListener(SSL_ACCESS_REVOKED_EVENT, onRevoked);
    return () => window.removeEventListener(SSL_ACCESS_REVOKED_EVENT, onRevoked);
  }, []);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-sm rounded-2xl bg-white p-6 text-center shadow-2xl">
        <h2 className="text-h4 text-gray-900 mb-2">Доступ к курсу закончился</h2>
        <p className="text-body-sm text-gray-600 mb-6">
          Чтобы продолжить прохождение, оформите доступ заново.
        </p>
        <Button
          variant="primary"
          fullWidth
          onClick={() => {
            setOpen(false);
            navigate("/payment");
          }}
        >
          Купить курс
        </Button>
      </div>
    </div>
  );
};
